import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addTrabajador } from "../../../../redux/actions/resolucion";
import TrabajadoresForm from "./TrabajadoresForm";

const initialValues = {
  permanente: true,
  cuil: "",
  idTrabajador: null,
  nombreApellidoTrabajador: "",
  nombreSector: "",
  nombrePuesto: "",
  idPuesto: null,
  idSector: null,
  fechaIngreso: null,
  sustanciasAsociadasAPuesto: [],
  examenes: {},
};

const TrabajadoresFormContainer = ({ editingRow, setShowForm }) => {
  const dispatch = useDispatch();
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const puestosAsociadosASustancias = useSelector(
    (state) => state.resolucion.postResolucion.puestos
  );
  const sustancias = useSelector(
    (state) => state.resolucion.postResolucion.sustancias
  );
  const trabajadores = useSelector(
    (state) => state.resolucion.postResolucion.trabajadores
  );
  const nomina = useSelector((state) => state.nomina.nominaActivaCombo.data);
  const [openExamenes, setOpenExamenes] = useState(false);
  const [valuesFormExamenes, setValuesFormExamenes] = useState(null);

  const handleSubmit = (values) => {
    dispatch(addTrabajador(values, values?.index));
    setShowForm(false);
  };

  const handleOpenExamenesMedicos = (rowData, values) => {
    setValuesFormExamenes({
      idSustancia: rowData.id,
      ...values["examenes"][rowData.id],
    });
    setOpenExamenes(true);
  };

  return (
    <>
      <TrabajadoresForm
        handleSubmit={handleSubmit}
        handleClose={() => setShowForm(false)}
        initialValues={editingRow || initialValues}
        idDependenciaEmpleador={idDependenciaEmpleador}
        nomina={nomina}
        puestosAsociadosASustancias={puestosAsociadosASustancias}
        sustancias={sustancias}
        openExamenes={openExamenes}
        setOpenExamenes={setOpenExamenes}
        handleOpenExamenesMedicos={handleOpenExamenesMedicos}
        valuesFormExamenes={valuesFormExamenes}
        trabajadores={trabajadores}
      />
    </>
  );
};

export default TrabajadoresFormContainer;
